import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ADSharedModule } from '@internal/common-ui/ad-shared';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { TreeModule } from 'primeng/tree';
import { AccountTreeComponent } from './components/account-tree/account-tree.component';
import { AdRichDropdownComponent } from './components/ad-rich-dropdown.component';
import { AdSearchListComponent } from './components/ad-search-list/ad-search-list.component';
import { AdSelectComponent } from './components/ad-select/ad-select.component';
import { DoubleTreeComponent } from './components/double-tree/double-tree.component';
import { DragDropCardComponent } from './components/dragdrop-card/dragdrop-card.component';
import { FilterDropdownComponent } from './components/filter-dropdown/filter-dropdown.component';
import { FilterListComponent } from './components/filter-list/filter-list.component';
import { FolderTreeComponent } from './components/folder-tree/folder-tree.component';
import { MovableTreeListComponent } from './components/movable-tree-list/movable-tree-list.component';
import { AdStepComponent } from './components/steps/ad-step.component';
import { TagComponent } from './components/tag/tag.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    TreeModule,
    AutoCompleteModule,
    DragDropModule,
    ADSharedModule,
    VirtualScrollerModule,
    InputTextModule,
  ],
  declarations: [
    AdRichDropdownComponent,
    FolderTreeComponent,
    AccountTreeComponent,
    DragDropCardComponent,
    FilterListComponent,
    FilterDropdownComponent,
    AdStepComponent,
    AdSelectComponent,
    AdSearchListComponent,
    TagComponent,
    DoubleTreeComponent,
    MovableTreeListComponent
  ],
  exports: [
    AdRichDropdownComponent,
    FolderTreeComponent,
    AccountTreeComponent,
    DragDropCardComponent,
    FilterListComponent,
    FilterDropdownComponent,
    AdStepComponent,
    AdSelectComponent,
    AdSearchListComponent,
    TagComponent,
    DoubleTreeComponent,
    MovableTreeListComponent
  ],
})
export class AdFormModule { }

